// Module
var code = `<template>
  <require from="./processed-vouchers-light-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>

  <div class="processed-vouchers-light-widget processed-vouchers-light-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .processed-vouchers-light-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .processed-vouchers-light-widget-\${id} {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .processed-vouchers-light-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>

    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}" class="processed-vouchers-light-widget__date">Date</th>
          <th style="\${columnWidths | columnWidths:1}" class="processed-vouchers-light-widget__voucher">Voucher NR</th>
          <th style="\${columnWidths | columnWidths:2}" class="processed-vouchers-light-widget__isin">ISIN/Org.nr</th>
          <th style="\${columnWidths | columnWidths:3}" class="processed-vouchers-light-widget__name">Name</th>
          <th style="\${columnWidths | columnWidths:4}">Action</th>
          <th style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">Quantity</th>
          <th style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">Amount</th>
          <th style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Dividend</th>
          <th style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">Interest</th>
          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">Profit</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">Profit (AVG)</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="v of data">
          <td style="\${columnWidths | columnWidths:0}" class="processed-vouchers-light-widget__date">\${v.lastDetail.lastTransactionDate | date:'dd.MM.yyyy'}</td>
          <td style="\${columnWidths | columnWidths:1}" class="processed-vouchers-light-widget__voucher">\${v.voucherNr}</td>
          <td style="\${columnWidths | columnWidths:2}" class="processed-vouchers-light-widget__isin">\${v.lastDetail.isin || v.lastDetail.orgNr}</td>
          <td style="\${columnWidths | columnWidths:3}" class="processed-vouchers-light-widget__name">\${v.lastDetail.name}</td>
          <td style="\${columnWidths | columnWidths:4}">\${v.lastDetail.lastActionType | actionType}</td>
          <td style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
            \${v.quantity | numericFormatter:quantityPrecision}
          </td>
          <td style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
            \${v.amount | numericFormatter:precision}
          </td>
          <td style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
            \${v.dividend | numericFormatter:precision}
          </td>
          <td style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
            \${v.interests | numericFormatter:precision}
            <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
          </td>
          <td if.bind="displayFifo" style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">
            \${v.profit | numericFormatter:precision}
          </td>
          <td if.bind="displayAvg" style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">
            \${v.avgProfit | numericFormatter:precision}
          </td>
        </tr>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;